import { Dispatch, MouseEvent, SetStateAction, useEffect, useState } from 'react';
import { Button, Input, Label, Modal, ModalInner, SelectBox, Text } from 'components';
import axios from 'common/AxiosAuth';
import { GroundStaionDetailData } from './types';
import { XOutlineIcon } from 'assets/svgs';
import { manageModalList, statusList } from './utils';
import DetailDeleteModal from './DetailDeleteModal';
import { convertAltitudeToKm } from 'utils';

interface ListElementProps {
  title: string;
  value: string | number;
}


interface ModalProps {
  data: GroundStaionDetailData | null;
  setData: Dispatch<SetStateAction<GroundStaionDetailData | null>>;
  onDelete?: (e: MouseEvent<HTMLButtonElement>) => void;
  onEdit?: (e: MouseEvent<HTMLButtonElement>) => void;
  onGroundStaionUpdated: () => Promise<void>;
}

const GroundStationModalListElement = ({ title, value }: ListElementProps) => {
  return (
    <li className="border-primary rounded-lg border px-3 py-2">
      <Text weight="regular" size="body2" color="tertiary">
        {title}
      </Text>
      <Text weight="regular" size="body2" color="primary">
        {value}
      </Text>
    </li>
  );
};

const GroundStationModal = ({ data, setData, onGroundStaionUpdated }: ModalProps) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false);
  const [city, setCity] = useState<string>('');
  const [latitude, setLatitude] = useState<number>(0);
  const [longitude, setLongitude] = useState<number>(0);
  const [altitude, setAltitude] = useState<number>(0);
  const [provider, setProvider] = useState<string>('');
  const [statusId, setStatus] = useState<number>(statusList[0].value);
  const [antennaVelocity, setAntennaVelocity] = useState<string>('');
  const [pointingAccuracy, setPointingAccuracy] = useState<string>('');
  const [antennaDiameter, setAntennaDiameter] = useState<string>('');
  const [frequency, setFrequency] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [registeredAt, setRegisteredAt] = useState<string>('');

  async function onSave () {
    console.log('12313123123',data);
    const params = {
      name: name, 
      city: city,
      altitudeMeters:altitude,
      latitudeDegrees:latitude,
      longitudeDegrees:longitude,
      providerName:provider,
      status:statusId,
      frequency:frequency
    };
    const groundstationRes = await axios.patch(`/api/admin/groundstation/${data?.id}`, params);
    console.log('groundstationRes',groundstationRes);
    onGroundStaionUpdated();
    setData(null);
    setIsEdit(false);
  };  

  useEffect(() => {
  },[data]);

  const onEdit = () => {
    setIsEdit(true);
    if(data) {
      setName(data['name']);
      setCity(data['city']);
      setLatitude(data['latitude']);
      setLongitude(data['longitude']);
      setAltitude(data['altitude']);
      setProvider(data['provider']);
      setStatus(data['statusId']);
      setAntennaVelocity(data['antennaVelocity']);
      setPointingAccuracy(data['pointingAccuracy']);
      setAntennaDiameter(data['antennaDiameter']);
      setFrequency(data['frequency']);
      setRegisteredAt(data['registeredAt']);
    }
  };

  const handleGoBack = () => {
    setIsEdit(false);
  };

  const openDeleteModal = () => {
    setIsDeleteModalOpened(true);
  };

  return (
    <>
      <Modal isOpened={!!data}>
        {/* input */}
        {isEdit && data && (
          <div className="h-fit w-[560px] rounded-2xl bg-white shadow-primary">
            <div className="flex flex-row items-center justify-between p-4">
              <Text size="body1" weight="semibold">{data.name}</Text>
              <button type="button" className="flex h-8 w-8 items-center justify-center" onClick={() => setData(null)}>
                <XOutlineIcon className="h-4 w-4" onClick={handleGoBack} />
              </button>
            </div>
            <ul className="flex max-h-[60vh] flex-col gap-4 overflow-auto px-4 pb-4">
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="Name" value={name} setValue={setName}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="City" value={city} setValue={setCity}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="Latitude" type="number" value={latitude} setValue={setLatitude}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="Longitude" type="number" value={longitude} setValue={setLongitude}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="Altitude" type="number" value={altitude} setValue={setAltitude}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="Provider" value={provider} setValue={setProvider}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <SelectBox
                  className="max-w-none"
                  bgColor="layer3"
                  label="Status"
                  list={statusList}
                  value={statusId}
                  setValue={setStatus}
                />
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="AntennaVelocity" value={antennaVelocity} setValue={setAntennaVelocity}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="PointingAccuracy" value={pointingAccuracy} setValue={setPointingAccuracy}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="AntennaDiameter" value={antennaDiameter} setValue={setAntennaDiameter}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="Frequency" value={frequency} setValue={setFrequency}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="G/T" value={statusId} setValue={setStatus}/>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <p className="text-text-tertiary font-regular text-body2">Registered At</p>
                <p className="text-text-primary font-regular text-body2">{data['createdDate']}</p>
              </li>
            </ul>
            <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
              <Button text="Delete" onClick={openDeleteModal} type="secondary" size="large" />
              <Button text="Save" onClick={onSave} type="primary" size="large" />
            </div>
          </div>
        )}

        {/* View */}
        {!isEdit && data && (
        <ModalInner title={data?.name} onClickClose={() => setData(null)}>
            <>
              <ul className="flex max-h-[60vh] flex-col gap-4 overflow-auto px-4 pb-4">
              {manageModalList.map(({ title, key }) => (
                  <GroundStationModalListElement key={key} title={title} value={data[key as keyof GroundStaionDetailData]} />
                  ))}
              </ul>
              <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
                <Button text="Delete" onClick={openDeleteModal} type="secondary" size="large" />
                <Button text="Edit" onClick={onEdit} type="primary" size="large"/>
              </div>
            </>
          </ModalInner>
        )}
      </Modal>
      {isDeleteModalOpened && (
        <DetailDeleteModal 
          data={data} 
          setData={setData}
          setIsDeleteModalOpened={setIsDeleteModalOpened}
          onDeleted={onGroundStaionUpdated} />
      )}
    </>
  );
};

export default GroundStationModal;
